import { Component, OnInit, Injectable } from '@angular/core';



@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css']
})

export class File implements OnInit {

  ngOnInit() {
   
  }
}
